import { useLocation } from "react-router";
import { useLayoutEffect } from "react";
//#region src/presentation/components/view-port/scroll-to-hash-element.tsx
var ScrollToHashElement = () => {
	const location = useLocation();
	useLayoutEffect(() => {
		const { hash } = location;
		if (!hash) return;
		const targetId = hash.slice(1);
		const targetElement = document.getElementById(targetId);
		if (targetElement) {
			targetElement.scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
			return;
		}
		const observer = new MutationObserver(() => {
			const updatedTargetElement = document.getElementById(targetId);
			if (updatedTargetElement) {
				updatedTargetElement.scrollIntoView({
					behavior: "smooth",
					block: "end"
				});
				observer.disconnect();
			}
		});
		observer.observe(document.body, {
			childList: true,
			subtree: true
		});
		return () => {
			observer.disconnect();
		};
	}, [location]);
	return null;
};
//#endregion
export { ScrollToHashElement };

//# sourceMappingURL=scroll-to-hash-element.js.map